const matchEntityLabelWithEntityStyle = (label, styleSheet) => {
  return styleSheet === null || styleSheet === void 0 ? void 0 : styleSheet.filter(s => s.label === label)[0];
};

export { matchEntityLabelWithEntityStyle as m };
